import classNames from 'classnames';
import { forwardRef, KeyboardEvent, MouseEvent } from 'react';

import { IconColor } from 'app/components/v3/components/Icon/helpers';
import { EvtKeys } from 'app/types';

import Button, { ButtonProps } from '../Button';
import Icon, { IconSize } from '../Icon';
import { IconName } from '../Icon/types';

// Local Typings
export interface IconButtonProps extends ButtonProps {
  alignIcon?: 'justified' | 'left' | 'right';
  iconColor?: IconColor;
  iconName: IconName;
  iconSize?: IconSize;
}

// Component Definition
const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(({
  alignIcon,
  iconColor,
  iconName,
  iconSize = 'xs',
  ...props
},
ref) => {
  const handleKeyDown = (evt: KeyboardEvent<HTMLButtonElement>) => {
    if (([EvtKeys.Enter, EvtKeys.Space] as string[]).includes(evt.key)) {
      evt.preventDefault();
      evt.stopPropagation();
      props.onClick?.(evt as unknown as MouseEvent<HTMLButtonElement>);
    }
  };

  return (
    <Button
      hierarchy="tertiary"
      {...props}
      className={classNames(props.className, 'icon-button')}
      marginLeft={(alignIcon === 'left' || alignIcon === 'justified') ? -1.5 : props.marginLeft}
      marginRight={(alignIcon === 'right' || alignIcon === 'justified') ? -1.5 : props.marginRight}
      onKeyDown={handleKeyDown}
      ref={ref}
      rel={props.href ? 'noopener noreferrer' : undefined}
      target={props.href ? '_blank' : undefined}
    >
      <Icon
        color={iconColor}
        name={iconName}
        size={iconSize}
      />
    </Button>
  );
});

export default IconButton;
